export default __webpack_public_path__ + "static/media/login.489542dc.svg";